'use client'

import { useSession } from 'next-auth/react'
import * as React from 'react'
const mergeLocalFlags = (flags: Set<string>, disabledFlagArr: string[], enabledFlagArr: string[]) => {
  disabledFlagArr?.forEach((flag) => {
    flags.delete(flag.trim())
  })

  enabledFlagArr?.forEach((flag) => {
    flags.add(flag.trim())
  })

  return flags
}

// It should be avoided at all costs to use this outside of the
// FeatureToggleProvider as doing so will trigger unnecessary queries.
const useFeatureFlags = (globalFlags: string[]): Set<string> => {
  const { data: sessionData } = useSession()
  const userFlags: string[] = sessionData?.user?.featureFlags ?? []

  const searchParams = new URLSearchParams(typeof document !== 'undefined' ? document.location.search : '')

  const envBlockedFlags = process.env.NEXT_PUBLIC_BLOCKED_FLAGS?.split(',')

  const envLocallyDisabledFlags = process.env.NEXT_PUBLIC_LOCALLY_DISABLED_FLAGS?.split(',')
  const envLocallyEnabledFlags = process.env.NEXT_PUBLIC_LOCALLY_ENABLED_FLAGS?.split(',')
  const queryParamLocallyDisabledFlags = (searchParams.get('locally_disabled_flags') as string)
    ?.split(',')
    .filter((flag) => !envBlockedFlags?.includes(flag))

  const queryParamLocallyEnabledFlags = (searchParams.get('locally_enabled_flags') as string)
    ?.split(',')
    .filter((flag) => !envBlockedFlags?.includes(flag))

  const localEnabledFlags = React.useMemo(
    () => [...(envLocallyEnabledFlags ?? []), ...(queryParamLocallyEnabledFlags ?? [])],
    [envLocallyEnabledFlags, queryParamLocallyEnabledFlags]
  )

  const localDisabledFlags = React.useMemo(
    () => [...(envLocallyDisabledFlags ?? []), ...(queryParamLocallyDisabledFlags ?? [])],
    [envLocallyDisabledFlags, queryParamLocallyDisabledFlags]
  )

  const featureFlags = mergeLocalFlags(
    !userFlags.length ? new Set(globalFlags) : new Set(userFlags),
    localDisabledFlags,
    localEnabledFlags
  )
  return featureFlags
}

export { useFeatureFlags }
